export const LABEL_SIZE_BASE = 'base';
export const LABEL_SIZE_SM = 'sm';

export type LabelSize = typeof LABEL_SIZE_BASE | typeof LABEL_SIZE_SM;
